// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__MwY2Q","label":"Radio_label__dkkT7","checkMark":"Radio_checkMark__2icm_","disabled":"Radio_disabled__2ZR14"};